<template>
	<div v-wechat-title="$route.meta.title">
		<div class="cs-container">
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
	export default {
		name: "login",
		data() {
			return {}
		},
	}
</script>

<style scoped>

</style>
